import React from 'react';
import { $class } from '../../../utils';
import './index.scss';

interface ICustomIcons {
  [key: string]: JSX.Element;
}

const customIcons: ICustomIcons = {
  bee: (
    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.71875 3.28125V3.77344L1.2851 7.37877C0.781111 7.90796 0.5 8.62038 0.5 9.35117C0.5 10.9045 1.7592 12.1875 3.3125 12.1875C4.04974 12.1875 4.72072 11.9038 5.22226 11.4397C5.66417 12.584 6.38511 13.6158 7.33781 14.4324L8 15L8.66219 14.4324C9.61489 13.6158 10.3358 12.584 10.7777 11.4397C11.2793 11.9038 11.9503 12.1875 12.6875 12.1875C14.2408 12.1875 15.5 10.9045 15.5 9.35117C15.5 8.62038 15.2189 7.90796 14.7149 7.37877L11.2812 3.77344V3.28125C11.2812 1.46907 9.81218 0 8 0C6.18782 0 4.71875 1.46907 4.71875 3.28125ZM6.15836 9.375C6.30839 10.8032 6.95917 12.1368 8 13.1353C9.04083 12.1368 9.69161 10.8032 9.84165 9.375H6.15836ZM9.875 7.96875V6.09375H6.125V7.96875H9.875ZM6.125 4.6875H9.875V3.28125C9.875 2.24572 9.03553 1.40625 8 1.40625C6.96447 1.40625 6.125 2.24572 6.125 3.28125V4.6875ZM2.30342 8.3486L4.71875 5.8125V9.375C4.71875 10.1517 4.08915 10.7812 3.3125 10.7812C2.55124 10.7812 1.90625 10.1433 1.90625 9.35117C1.90625 8.97645 2.0519 8.61269 2.30342 8.3486ZM11.2812 9.375V5.8125L13.6966 8.3486C13.9481 8.61269 14.0938 8.97645 14.0938 9.35117C14.0938 10.1433 13.4488 10.7812 12.6875 10.7812C11.9108 10.7812 11.2812 10.1517 11.2812 9.375Z"
        fill="#2A3038"
      />
    </svg>
  ),
  activity: (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 2.5H3V7H4.53647L5.78647 4.5H7.73293L10.2329 10H10.2865L11.5365 7.5H14V2.5Z"
        fill="#2A3038"
        fillOpacity="0.15"
      />
      <path
        d="M14 13.5V9H12.4635L11.2135 11.5H9.26707L6.76707 6H6.71353L5.46353 8.5H3V13.5H14Z"
        fill="#2A3038"
        fillOpacity="0.15"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 1H15.5V15H1.5V1ZM3 2.5H14V7.5H11.5365L10.2865 10H10.2329L7.73293 4.5H5.78647L4.53647 7H3V2.5ZM14 9V13.5H3V8.5H5.46353L6.71353 6H6.76707L9.26707 11.5H11.2135L12.4635 9H14Z"
        fill="#2A3038"
      />
    </svg>
  ),
  cake: (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 7.5C3 7.22386 3.22386 7 3.5 7H13.5C13.7761 7 14 7.22386 14 7.5V9.25H3V7.5Z"
        fill="#2A3038"
        fillOpacity="0.15"
      />
      <path
        d="M5.25 1C5.25 1.55228 4.80228 2 4.25 2C3.69772 2 3.25 1.55228 3.25 1C3.25 0.447715 3.69772 0 4.25 0C4.80228 0 5.25 0.447715 5.25 1Z"
        fill="#2A3038"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 5.5H7.75V3.5H9.25V5.5H12V3.5H13.5V5.5C14.6046 5.5 15.5 6.39543 15.5 7.5V15H1.5V7.5C1.5 6.39543 2.39543 5.5 3.5 5.5V3.5H5V5.5ZM3 7.5C3 7.22386 3.22386 7 3.5 7H13.5C13.7761 7 14 7.22386 14 7.5V9.25H3V7.5ZM3 10.75V13.5H14V10.75H3Z"
        fill="#2A3038"
      />
      <path
        d="M8.5 2C9.05228 2 9.5 1.55228 9.5 1C9.5 0.447715 9.05228 0 8.5 0C7.94772 0 7.5 0.447715 7.5 1C7.5 1.55228 7.94772 2 8.5 2Z"
        fill="#2A3038"
      />
      <path
        d="M13.75 1C13.75 1.55228 13.3023 2 12.75 2C12.1977 2 11.75 1.55228 11.75 1C11.75 0.447715 12.1977 0 12.75 0C13.3023 0 13.75 0.447715 13.75 1Z"
        fill="#2A3038"
      />
    </svg>
  ),
  users: (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 5C6.94036 5 7.5 4.44036 7.5 3.75C7.5 3.05964 6.94036 2.5 6.25 2.5C5.55964 2.5 5 3.05964 5 3.75C5 4.44036 5.55964 5 6.25 5Z"
        fill="#2A3038"
        fillOpacity="0.15"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.25 4.25C13.25 4.66421 12.9142 5 12.5 5C12.0858 5 11.75 4.66421 11.75 4.25C11.75 3.83579 12.0858 3.5 12.5 3.5C12.9142 3.5 13.25 3.83579 13.25 4.25Z"
        fill="#2A3038"
        fillOpacity="0.15"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 11V13.5H10.5V9.5H13.5C14.3284 9.5 15 10.1716 15 11ZM9 9.5V13.5H2V11C2 10.1716 2.67157 9.5 3.5 9.5H9Z"
        fill="#2A3038"
        fillOpacity="0.15"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 6.5C7.76878 6.5 9 5.26878 9 3.75C9 2.23122 7.76878 1 6.25 1C4.73122 1 3.5 2.23122 3.5 3.75C3.5 5.26878 4.73122 6.5 6.25 6.5ZM6.25 5C6.94036 5 7.5 4.44036 7.5 3.75C7.5 3.05964 6.94036 2.5 6.25 2.5C5.55964 2.5 5 3.05964 5 3.75C5 4.44036 5.55964 5 6.25 5Z"
        fill="#2A3038"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.75 4.25C14.75 5.49264 13.7426 6.5 12.5 6.5C11.2574 6.5 10.25 5.49264 10.25 4.25C10.25 3.00736 11.2574 2 12.5 2C13.7426 2 14.75 3.00736 14.75 4.25ZM13.25 4.25C13.25 4.66421 12.9142 5 12.5 5C12.0858 5 11.75 4.66421 11.75 4.25C11.75 3.83579 12.0858 3.5 12.5 3.5C12.9142 3.5 13.25 3.83579 13.25 4.25Z"
        fill="#2A3038"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5 8C15.1569 8 16.5 9.34315 16.5 11V15H0.5V11C0.5 9.34315 1.84315 8 3.5 8H13.5ZM15 11V13.5H10.5V9.5H13.5C14.3284 9.5 15 10.1716 15 11ZM9 9.5V13.5H2V11C2 10.1716 2.67157 9.5 3.5 9.5H9Z"
        fill="#2A3038"
      />
    </svg>
  ),
  sliders: (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 2.5H7.5V5.5H5V2.5Z"
        fill="#2A3038"
        fillOpacity="0.15"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5 10.5H12V13.5H9.5V10.5Z"
        fill="#2A3038"
        fillOpacity="0.15"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 3.25H15.5V4.75H9V7H3.5V4.75H1.5V3.25H3.5V1H9V3.25ZM5 2.5H7.5V5.5H5V2.5Z"
        fill="#2A3038"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 11.25V9H13.5V11.25H15.5V12.75H13.5V15H8V12.75H1.5V11.25H8ZM9.5 10.5H12V13.5H9.5V10.5Z"
        fill="#2A3038"
      />
    </svg>
  ),
  bee_yellow: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.05337 15C9.29343 17.2851 10.3347 19.4189 12 21.0164C13.6653 19.4189 14.7066 17.2851 14.9466 15H9.05337ZM9 7.5H15V5.25C15 3.59315 13.6569 2.25 12 2.25C10.3431 2.25 9 3.59315 9 5.25V7.5Z"
        fill="#F1B729"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75 5.25V6.0375L1.25616 11.806C0.449778 12.6527 0 13.7926 0 14.9619C0 17.4471 2.01472 19.5 4.5 19.5C5.67958 19.5 6.75315 19.0461 7.55562 18.3035C8.26268 20.1344 9.41618 21.7853 10.9405 23.0919L12 24L13.0595 23.0919C14.5838 21.7853 15.7373 20.1344 16.4444 18.3035C17.2468 19.0461 18.3204 19.5 19.5 19.5C21.9853 19.5 24 17.4471 24 14.9619C24 13.7926 23.5502 12.6527 22.7438 11.806L17.25 6.0375V5.25C17.25 2.35051 14.8995 0 12 0C9.1005 0 6.75 2.35051 6.75 5.25ZM9.05337 15C9.29343 17.2851 10.3347 19.4189 12 21.0164C13.6653 19.4189 14.7066 17.2851 14.9466 15H9.05337ZM15 12.75V9.75H9V12.75H15ZM9 7.5H15V5.25C15 3.59315 13.6569 2.25 12 2.25C10.3431 2.25 9 3.59315 9 5.25V7.5ZM2.88547 13.3578L6.75 9.3V15C6.75 16.2426 5.74264 17.25 4.5 17.25C3.28198 17.25 2.25 16.2293 2.25 14.9619C2.25 14.3623 2.48305 13.7803 2.88547 13.3578ZM17.25 15V9.3L21.1145 13.3578C21.517 13.7803 21.75 14.3623 21.75 14.9619C21.75 16.2293 20.718 17.25 19.5 17.25C18.2574 17.25 17.25 16.2426 17.25 15Z"
        fill="#2A3038"
      />
    </svg>
  ),
  search: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0625 7.875C14.0625 11.2923 11.2923 14.0625 7.875 14.0625C4.45774 14.0625 1.6875 11.2923 1.6875 7.875C1.6875 4.45774 4.45774 1.6875 7.875 1.6875C11.2923 1.6875 14.0625 4.45774 14.0625 7.875ZM6.28401 9.46599L5.09077 10.6592C3.55308 9.12154 3.55308 6.62846 5.09077 5.09077C6.62846 3.55308 9.12155 3.55308 10.6592 5.09077L9.46599 6.28401C8.58731 5.40533 7.16269 5.40533 6.28401 6.28401C5.40533 7.16269 5.40533 8.58731 6.28401 9.46599Z"
        fill="#2A3038"
        fillOpacity="0.15"
      />
      <path
        d="M5.09077 10.6592L6.28401 9.46599C5.40533 8.58731 5.40533 7.16269 6.28401 6.28401C7.16269 5.40533 8.58731 5.40533 9.46599 6.28401L10.6592 5.09077C9.12155 3.55308 6.62846 3.55308 5.09077 5.09077C3.55308 6.62846 3.55308 9.12154 5.09077 10.6592Z"
        fill="#2A3038"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.875 15.75C9.74568 15.75 11.464 15.0977 12.815 14.0082L16.7846 17.9779L17.9779 16.7846L14.0082 12.815C15.0977 11.464 15.75 9.74568 15.75 7.875C15.75 3.52576 12.2242 0 7.875 0C3.52576 0 0 3.52576 0 7.875C0 12.2242 3.52576 15.75 7.875 15.75ZM7.875 14.0625C11.2923 14.0625 14.0625 11.2923 14.0625 7.875C14.0625 4.45774 11.2923 1.6875 7.875 1.6875C4.45774 1.6875 1.6875 4.45774 1.6875 7.875C1.6875 11.2923 4.45774 14.0625 7.875 14.0625Z"
        fill="#2A3038"
      />
    </svg>
  ),
  gift: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75 2.25V5.25H10.875V4.5C10.875 3.25736 9.86764 2.25 8.625 2.25H6.75ZM17.25 2.25V5.25H13.125V4.5C13.125 3.25736 14.1324 2.25 15.375 2.25H17.25ZM20.25 12.75V20.25H13.125V12.75H20.25ZM10.875 12.75V20.25H3.75V12.75H10.875Z"
        fill="#2A3038"
        fillOpacity="0.15"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.625 0C9.96903 0 11.1754 0.589225 12 1.52345C12.8246 0.589225 14.031 0 15.375 0H19.5V5.25H24V12.75H22.5V22.5H1.5V12.75H0V5.25H4.5V0H8.625ZM6.75 2.25V5.25H10.875V4.5C10.875 3.25736 9.86764 2.25 8.625 2.25H6.75ZM21.75 7.5V10.5H2.25V7.5H21.75ZM17.25 2.25V5.25H13.125V4.5C13.125 3.25736 14.1324 2.25 15.375 2.25H17.25ZM20.25 12.75V20.25H13.125V12.75H20.25ZM10.875 12.75V20.25H3.75V12.75H10.875Z"
        fill="#2A3038"
      />
    </svg>
  ),
  trophy: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 3H10V15C10 18.3137 12.6863 21 16 21C19.3137 21 22 18.3137 22 15V3Z"
        fill="#2A3038"
        fillOpacity="0.15"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25 4V0H7V4H0V8C0 12.6232 3.1373 16.5136 7.39907 17.6584C8.38973 20.8672 11.1267 23.3096 14.5 23.8756V29H8V32H24V29H17.5V23.8756C20.8733 23.3096 23.6103 20.8672 24.6009 17.6584C28.8627 16.5136 32 12.6232 32 8V4H25ZM22 3H10V15C10 18.3137 12.6863 21 16 21C19.3137 21 22 18.3137 22 15V3ZM25 7V14.3264C27.3649 13.2029 29 10.7924 29 8V7H25ZM3 7H7V14.3264C4.63505 13.2029 3 10.7924 3 8V7Z"
        fill="#2A3038"
      />
    </svg>
  ),
  save: (
    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.84375 2.34375H10.23L13.1562 5.26999V12.6562H11.2812L11.2812 8.4375L4.71875 8.4375L4.71875 12.6562H2.84375V2.34375Z"
        fill="#2A3038"
        fillOpacity="0.15"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.4375 14.0625V0.9375H10.8125L14.5625 4.6875V14.0625H1.4375ZM2.84375 2.34375H10.23L13.1562 5.26999V12.6562H11.2812L11.2812 8.4375L4.71875 8.4375L4.71875 12.6562H2.84375V2.34375ZM9.875 12.6562H6.125L6.125 9.84375H9.875V12.6562Z"
        fill="#2A3038"
      />
    </svg>
  ),
  fire: (
    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.1562 8.4375C13.1562 10.3669 12.0966 12.0487 10.5275 12.9328C10.5607 12.7677 10.5781 12.5968 10.5781 12.4219C10.5781 11.0563 10.0314 9.97659 9.50614 9.25441C9.24255 8.89196 8.97901 8.6118 8.77946 8.42057C8.67939 8.32467 8.59453 8.25029 8.53259 8.1983C8.36175 8.05493 8.17817 7.9266 8 7.79297C7.82183 7.9266 7.63825 8.05493 7.46741 8.1983C7.40547 8.25029 7.32061 8.32467 7.22054 8.42057C7.02099 8.6118 6.75745 8.89196 6.49386 9.25441C5.96863 9.97659 5.42188 11.0563 5.42188 12.4219C5.42188 12.5968 5.4393 12.7677 5.47251 12.9328C3.90342 12.0487 2.84375 10.3669 2.84375 8.4375C2.84375 7.19727 3.3798 6.07364 3.99261 5.20549C4.25121 4.83914 4.51056 4.53691 4.72061 4.31304C4.7701 5.56375 5.79966 6.5625 7.0625 6.5625C8.35692 6.5625 9.40625 5.51317 9.40625 4.21875V1.40625H9.4428C9.52482 1.46621 9.62126 1.53929 9.72894 1.62544C10.1108 1.93088 10.6249 2.39336 11.1384 3.00963C12.1642 4.24054 13.1562 6.04231 13.1562 8.4375Z"
        fill="#2A3038"
        fillOpacity="0.15"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 15C11.6244 15 14.5625 12.0619 14.5625 8.4375C14.5625 2.8125 9.875 0 9.875 0H8V4.21875C8 4.73652 7.58027 5.15625 7.0625 5.15625C6.54473 5.15625 6.125 4.73652 6.125 4.21875V2.8125H4.25C4.25 2.8125 1.4375 5.15625 1.4375 8.4375C1.4375 12.0619 4.37563 15 8 15ZM8 13.5938C8.64721 13.5938 9.17188 13.0691 9.17188 12.4219C9.17188 11.4437 8.78113 10.6484 8.36886 10.0815C8.2417 9.90669 8.11452 9.75651 8 9.6329C7.88548 9.75651 7.7583 9.90669 7.63114 10.0815C7.21887 10.6484 6.82812 11.4437 6.82812 12.4219C6.82812 13.0691 7.35279 13.5938 8 13.5938ZM13.1562 8.4375C13.1562 10.3669 12.0966 12.0487 10.5275 12.9328C10.5607 12.7677 10.5781 12.5968 10.5781 12.4219C10.5781 11.0563 10.0314 9.97659 9.50614 9.25441C9.24255 8.89196 8.97901 8.6118 8.77946 8.42057C8.67939 8.32467 8.59453 8.25029 8.53259 8.1983C8.40878 8.0944 8.27829 7.9984 8.148 7.90255C8.09851 7.86614 8.04905 7.82976 8 7.79297C7.95095 7.82976 7.90149 7.86614 7.852 7.90255C7.72171 7.9984 7.59122 8.0944 7.46741 8.1983C7.40547 8.25029 7.32061 8.32467 7.22054 8.42057C7.02099 8.6118 6.75745 8.89196 6.49386 9.25441C5.96863 9.97659 5.42188 11.0563 5.42188 12.4219C5.42188 12.5968 5.4393 12.7677 5.47251 12.9328C3.90342 12.0487 2.84375 10.3669 2.84375 8.4375C2.84375 7.19727 3.3798 6.07364 3.99261 5.20549C4.25121 4.83914 4.51056 4.53691 4.72061 4.31304C4.7701 5.56375 5.79966 6.5625 7.0625 6.5625C8.35692 6.5625 9.40625 5.51317 9.40625 4.21875V1.40625H9.44279C9.52482 1.46621 9.62126 1.53929 9.72894 1.62544C10.1108 1.93088 10.6249 2.39336 11.1384 3.00963C12.1642 4.24054 13.1562 6.04231 13.1562 8.4375Z"
        fill="#2A3038"
      />
    </svg>
  ),
  list: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 3.5V7.25H12.5V3.5H3.5ZM12.5 12.5H3.5V8.75H12.5V12.5Z"
        fill="black"
        fillOpacity="0.15"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 0V16H3.5V14H12.5V16H14V0H12.5V2H3.5V0H2ZM3.5 3.5V7.25H12.5V3.5H3.5ZM12.5 12.5H3.5V8.75H12.5V12.5Z"
        fill="#2A3038"
      />
    </svg>
  ),
  columns: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 13.5L12.5 6L10.5 6L10.5 13.5L12.5 13.5Z"
        fill="#2A3038"
        fillOpacity="0.15"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 6L5.5 9.5L3.5 9.5L3.5 6L5.5 6Z"
        fill="#2A3038"
        fillOpacity="0.15"
      />
      <path d="M1 2.5L15 2.5V1L1 1L1 2.5Z" fill="#2A3038" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 4.5L9 4.5L9 15L14 15L14 4.5ZM12.5 13.5L12.5 6H10.5L10.5 13.5L12.5 13.5Z"
        fill="#2A3038"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 4.5L7 11H2L2 4.5L7 4.5ZM5.5 6L5.5 9.5H3.5V6H5.5Z"
        fill="#2A3038"
      />
    </svg>
  ),
  new_orders: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75 18.75C6.75 19.5784 6.07843 20.25 5.25 20.25C4.42157 20.25 3.75 19.5784 3.75 18.75C3.75 17.9216 4.42157 17.25 5.25 17.25C6.07843 17.25 6.75 17.9216 6.75 18.75Z"
        fill="#F1B729"
      />
      <path
        d="M1.5 1.5H5.25C14.7769 1.5 22.5 9.22309 22.5 18.75V22.5H20.25V18.75C20.25 10.4657 13.5343 3.75 5.25 3.75H1.5V1.5Z"
        fill="#2A3038"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.25 22.5C7.32107 22.5 9 20.8211 9 18.75C9 16.6789 7.32107 15 5.25 15C3.17893 15 1.5 16.6789 1.5 18.75C1.5 20.8211 3.17893 22.5 5.25 22.5ZM5.25 20.25C6.07843 20.25 6.75 19.5784 6.75 18.75C6.75 17.9216 6.07843 17.25 5.25 17.25C4.42157 17.25 3.75 17.9216 3.75 18.75C3.75 19.5784 4.42157 20.25 5.25 20.25Z"
        fill="#2A3038"
      />
      <path
        d="M5.25 8.25H1.5V10.5H5.25C9.80635 10.5 13.5 14.1937 13.5 18.75V22.5H15.75V18.75C15.75 12.951 11.049 8.25 5.25 8.25Z"
        fill="#2A3038"
      />
    </svg>
  ),
  rule: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.0718 4.57735L8 1.1547L13.9282 4.57735V11.4227L8 14.8453L2.0718 11.4227V4.57735Z"
        stroke="#2A3038"
        strokeWidth="2"
      />
      <path
        d="M7.26795 7.57735L8 7.1547L8.73205 7.57735V8.42265L8 8.8453L7.26795 8.42265V7.57735Z"
        stroke="#2A3038"
        strokeWidth="2"
      />
    </svg>
  ),
  hexagon: (
    <svg width="30" height="34" viewBox="0 0 30 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 0.57735C14.6188 0.220085 15.3812 0.220085 16 0.57735L28.7224 7.92265C29.3412 8.27992 29.7224 8.94017 29.7224 9.6547V24.3453C29.7224 25.0598 29.3412 25.7201 28.7224 26.0774L16 33.4226C15.3812 33.7799 14.6188 33.7799 14 33.4226L1.27757 26.0774C0.658766 25.7201 0.277568 25.0598 0.277568 24.3453V9.6547C0.277568 8.94017 0.658766 8.27991 1.27757 7.92265L14 0.57735Z"
        fill="#BFC6CF"
      />
    </svg>
  ),
  user: (
    <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 3C9 4.65685 7.65685 6 6 6C4.34315 6 3 4.65685 3 3C3 1.34315 4.34315 0 6 0C7.65685 0 9 1.34315 9 3ZM6 4.5C6.82843 4.5 7.5 3.82843 7.5 3C7.5 2.17157 6.82843 1.5 6 1.5C5.17157 1.5 4.5 2.17157 4.5 3C4.5 3.82843 5.17157 4.5 6 4.5Z"
        fill="#2A3038"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 8C10.6569 8 12 9.34315 12 11V14H0V11C0 9.34315 1.34315 8 3 8H9ZM10.5 11C10.5 10.1716 9.82843 9.5 9 9.5H3C2.17157 9.5 1.5 10.1716 1.5 11V12.5H10.5V11Z"
        fill="#2A3038"
      />
    </svg>
  ),
  drag_handle: (
    <svg width="12" height="18" viewBox="0 0 12 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.2429 4.48579C3.48161 4.48579 4.48579 3.48161 4.48579 2.2429C4.48579 1.00418 3.48161 0 2.2429 0C1.00418 0 0 1.00418 0 2.2429C0 3.48161 1.00418 4.48579 2.2429 4.48579Z"
        fill="#CCD1D9"
      />
      <path
        d="M8.94309 4.48579C10.1818 4.48579 11.186 3.48161 11.186 2.2429C11.186 1.00418 10.1818 0 8.94309 0C7.70437 0 6.7002 1.00418 6.7002 2.2429C6.7002 3.48161 7.70437 4.48579 8.94309 4.48579Z"
        fill="#CCD1D9"
      />
      <path
        d="M2.2429 11.2428C3.48161 11.2428 4.48579 10.2386 4.48579 8.99988C4.48579 7.76117 3.48161 6.75699 2.2429 6.75699C1.00418 6.75699 0 7.76117 0 8.99988C0 10.2386 1.00418 11.2428 2.2429 11.2428Z"
        fill="#CCD1D9"
      />
      <path
        d="M8.94309 11.2428C10.1818 11.2428 11.186 10.2386 11.186 8.99988C11.186 7.76117 10.1818 6.75699 8.94309 6.75699C7.70437 6.75699 6.7002 7.76117 6.7002 8.99988C6.7002 10.2386 7.70437 11.2428 8.94309 11.2428Z"
        fill="#CCD1D9"
      />
      <path
        d="M2.2429 18C3.48161 18 4.48579 16.9959 4.48579 15.7571C4.48579 14.5184 3.48161 13.5143 2.2429 13.5143C1.00418 13.5143 0 14.5184 0 15.7571C0 16.9959 1.00418 18 2.2429 18Z"
        fill="#CCD1D9"
      />
      <path
        d="M8.94309 18C10.1818 18 11.186 16.9959 11.186 15.7571C11.186 14.5184 10.1818 13.5143 8.94309 13.5143C7.70437 13.5143 6.7002 14.5184 6.7002 15.7571C6.7002 16.9959 7.70437 18 8.94309 18Z"
        fill="#CCD1D9"
      />
    </svg>
  ),
  arrow_vertical: (
    <svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.8754 1.43766C7.6709 1.42771 7.5384 1.41545 7.40513 1.41545C6.0334 1.41545 4.66167 1.42005 3.28918 1.41545C2.65041 1.41162 2.27971 0.864003 2.60446 0.374592C2.72394 0.194605 3.00732 0.0222767 3.21718 0.019979C5.35098 -0.00606168 7.48555 6.21728e-05 9.61936 0.00695529C10.0689 0.00695529 10.3454 0.301829 10.3462 0.759838C10.3498 2.86913 10.3498 4.97792 10.3462 7.08619C10.3462 7.55263 10.0506 7.86205 9.63621 7.86129C9.23564 7.86129 8.93847 7.54037 8.93694 7.07317C8.93004 5.70144 8.93694 4.32894 8.93694 2.95721V2.44329C8.75465 2.61638 8.64743 2.71366 8.54556 2.81552C6.28768 5.06727 4.03031 7.32056 1.77345 9.57537C1.2917 10.0571 0.89956 10.1261 0.561797 9.79212C0.224034 9.45819 0.286839 9.05226 0.759401 8.5797C3.0229 6.3157 5.28614 4.05194 7.54912 1.78844C7.64716 1.69347 7.73371 1.59161 7.8754 1.43766Z"
        fill="#F1B729"
      />
    </svg>
  ),
  x: (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.9394 6L0.469727 1.53033L1.53039 0.469666L6.00006 4.93934L10.4697 0.469666L11.5304 1.53033L7.06072 6L11.5304 10.4697L10.4697 11.5303L6.00006 7.06066L1.53039 11.5303L0.469727 10.4697L4.9394 6Z"
        fill="#2A3038"
      />
    </svg>
  ),
  copy: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0H10V4H4V10H0V0Z" fill="#E0E0E0" />
      <path d="M16 6H6V16H16V6Z" fill="#E0E0E0" />
    </svg>
  ),
  arr_right: (
    <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 6.75L0 6.75L6.55671e-08 5.25L8 5.25L8 0L10 8.74225e-08L16 6L10 12H8L8 6.75ZM13.8787 6L9.5 1.62132L9.5 10.3787L13.8787 6Z"
        fill="black"
      />
    </svg>
  ),
  wifi: (
    <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 2.14124C10.1633 2.14124 12.2381 3.00062 13.7678 4.53033L14.9393 5.7019L16 4.64124L14.8284 3.46967C14.6021 3.24329 14.3656 3.02931 14.1201 2.82817C12.4017 1.4202 10.241 0.641239 8 0.641239C5.43884 0.641239 2.98258 1.65865 1.17157 3.46967L0 4.64124L1.06066 5.7019L2.23223 4.53033C3.76194 3.00062 5.83667 2.14124 8 2.14124Z"
        fill="black"
      />
      <path
        d="M3.88909 8.53033L2.82843 7.46967L4.00001 6.29809C5.06087 5.23723 6.49971 4.64124 8.00001 4.64124C9.5003 4.64124 10.9391 5.23723 12 6.29809L13.1716 7.46966L12.1109 8.53032L10.9393 7.35876C10.1598 6.57919 9.10247 6.14124 8.00001 6.14124C6.89754 6.14124 5.84023 6.57919 5.06067 7.35875L3.88909 8.53033Z"
        fill="black"
      />
      <path
        d="M6.71752 11.3588L5.65686 10.2981L6.82844 9.12652C7.13916 8.8158 7.56059 8.64124 8.00001 8.64124C8.43944 8.64124 8.86086 8.8158 9.17159 9.12652L10.3432 10.2981L9.28249 11.3587L8.11093 10.1872C8.08151 10.1578 8.04161 10.1412 8.00001 10.1412C7.95841 10.1412 7.91851 10.1578 7.8891 10.1872L6.71752 11.3588Z"
        fill="black"
      />
    </svg>
  ),
  arrow_back: (
    <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 13H4L0 9L4 5H5V8H11C12.6569 8 14 6.65685 14 5C14 3.34315 12.6569 2 11 2H4V0H11C13.7614 0 16 2.23858 16 5C16 7.76142 13.7614 10 11 10H5V13Z"
        fill="#F1B729"
      />
    </svg>
  ),
  icons_menu_point: (
    <svg width="22" height="6" viewBox="0 0 22 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.75843 5.75868C4.28201 5.75868 5.51711 4.52358 5.51711 3C5.51711 1.47643 4.28201 0.241325 2.75843 0.241325C1.23486 0.241325 -0.000244141 1.47643 -0.000244141 3C-0.000244141 4.52358 1.23486 5.75868 2.75843 5.75868Z"
        fill="#BFC6CF"
      />
      <path
        d="M10.9994 5.75868C12.523 5.75868 13.7581 4.52358 13.7581 3C13.7581 1.47643 12.523 0.241325 10.9994 0.241325C9.47583 0.241325 8.24072 1.47643 8.24072 3C8.24072 4.52358 9.47583 5.75868 10.9994 5.75868Z"
        fill="#BFC6CF"
      />
      <path
        d="M19.2413 5.75868C20.7649 5.75868 22 4.52358 22 3C22 1.47643 20.7649 0.241325 19.2413 0.241325C17.7178 0.241325 16.4827 1.47643 16.4827 3C16.4827 4.52358 17.7178 5.75868 19.2413 5.75868Z"
        fill="#BFC6CF"
      />
    </svg>
  ),
  copy_icon: (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.5 0H10.5V4H4.5V10H0.5V0Z" fill="#E0E0E0" />
      <path d="M16.5 6H6.5V16H16.5V6Z" fill="#E0E0E0" />
    </svg>
  ),
  three_dots: (
    <svg width="22" height="6" viewBox="0 0 22 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.75868 5.75869C4.28225 5.75869 5.51735 4.52358 5.51735 3.00001C5.51735 1.47643 4.28225 0.241333 2.75868 0.241333C1.2351 0.241333 0 1.47643 0 3.00001C0 4.52358 1.2351 5.75869 2.75868 5.75869Z"
        fill="#BFC6CF"
      />
      <path
        d="M10.9999 5.75869C12.5235 5.75869 13.7586 4.52358 13.7586 3.00001C13.7586 1.47643 12.5235 0.241333 10.9999 0.241333C9.47631 0.241333 8.24121 1.47643 8.24121 3.00001C8.24121 4.52358 9.47631 5.75869 10.9999 5.75869Z"
        fill="#BFC6CF"
      />
      <path
        d="M19.2421 5.75869C20.7657 5.75869 22.0008 4.52358 22.0008 3.00001C22.0008 1.47643 20.7657 0.241333 19.2421 0.241333C17.7185 0.241333 16.4834 1.47643 16.4834 3.00001C16.4834 4.52358 17.7185 5.75869 19.2421 5.75869Z"
        fill="#BFC6CF"
      />
    </svg>
  ),
  plus: (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 1.42529H6V6.42529L1 6.42529V10.4253H6V15.4253H10V10.4253H15V6.42529L10 6.42529V1.42529Z"
        fill="#F1B729"
      />
    </svg>
  ),
  icons_add_time: (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5 18C14.4706 18 18.5 13.9706 18.5 9C18.5 4.02944 14.4706 0 9.5 0C4.52944 0 0.5 4.02944 0.5 9C0.5 13.9706 4.52944 18 9.5 18ZM8.375 7.875V4.5H10.625V7.875H14V10.125H10.625V13.5H8.375V10.125H5V7.875H8.375Z"
        fill="#E0E0E0"
      />
    </svg>
  ),
  pen: (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.29289 3.70711L0 11V15H4L11.2929 7.70711L7.29289 3.70711Z" fill="#F1B729" />
      <path
        d="M8.70711 2.29289L12.7071 6.29289L14.1716 4.82843C14.702 4.29799 15 3.57857 15 2.82843C15 1.26633 13.7337 0 12.1716 0C11.4214 0 10.702 0.297995 10.1716 0.828428L8.70711 2.29289Z"
        fill="#F1B729"
      />
    </svg>
  ),
  pen_white: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.29289 3.70711L1 11V15H5L12.2929 7.70711L8.29289 3.70711Z" fill="white" />
      <path
        d="M9.70711 2.29289L13.7071 6.29289L15.1716 4.82843C15.702 4.29799 16 3.57857 16 2.82843C16 1.26633 14.7337 0 13.1716 0C12.4214 0 11.702 0.297995 11.1716 0.828428L9.70711 2.29289Z"
        fill="white"
      />
    </svg>
  ),
  icons_add_but: (
    <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.9139 3.41424L5.49966 12.8285L0.0854492 7.41424L2.91388 4.58582L5.49966 7.1716L12.0854 0.585815L14.9139 3.41424Z"
        fill="white"
      />
    </svg>
  ),
  cog: (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.68596 0.925293H9.68596L10.2798 3.30077C10.9136 3.53679 11.4966 3.87685 12.0083 4.30018L14.3642 3.62626L15.8642 6.22433L14.1033 7.92695C14.1577 8.25164 14.186 8.58516 14.186 8.92529C14.186 9.26543 14.1577 9.59895 14.1033 9.92364L15.8642 11.6263L14.3642 14.2243L12.0083 13.5504C11.4966 13.9737 10.9136 14.3138 10.2798 14.5498L9.68596 16.9253H6.68596L6.09209 14.5498C5.45836 14.3138 4.87528 13.9737 4.36362 13.5504L2.00775 14.2243L0.507751 11.6263L2.26864 9.92364C2.21426 9.59895 2.18595 9.26543 2.18595 8.92529C2.18595 8.58516 2.21426 8.25164 2.26864 7.92695L0.507751 6.22433L2.00775 3.62625L4.36362 4.30018C4.87528 3.87685 5.45836 3.53679 6.09209 3.30077L6.68596 0.925293ZM8.18596 10.9253C9.29052 10.9253 10.186 10.0299 10.186 8.92529C10.186 7.82072 9.29052 6.92529 8.18596 6.92529C7.08139 6.92529 6.18596 7.82072 6.18596 8.92529C6.18596 10.0299 7.08139 10.9253 8.18596 10.9253Z"
        fill="#CCD1D9"
      />
    </svg>
  ),
  expandIcon: (
    <svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.65338 3.11655L13.8068 9.26993L15 8.07668L7.65338 0.730064L0.306758 8.07668L1.5 9.26993L7.65338 3.11655Z"
        fill="#41474E"
      />
    </svg>
  ),
  three_dots_vertical: (
    <svg width="6" height="18" viewBox="0 0 6 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.931321 2.81901C0.931321 3.96169 1.85765 4.88802 3.00033 4.88802C4.14301 4.88802 5.06934 3.96169 5.06934 2.81901C5.06934 1.67633 4.14301 0.75 3.00033 0.75C1.85765 0.75 0.931321 1.67633 0.931321 2.81901Z"
        fill="#BFC6CF"
      />
      <path
        d="M0.931321 8.99967C0.931321 10.1424 1.85765 11.0687 3.00033 11.0687C4.14301 11.0687 5.06934 10.1424 5.06934 8.99967C5.06934 7.85699 4.14301 6.93066 3.00033 6.93066C1.85765 6.93066 0.931321 7.85699 0.931321 8.99967Z"
        fill="#BFC6CF"
      />
      <path
        d="M0.931321 15.1813C0.931321 16.324 1.85765 17.2503 3.00033 17.2503C4.14301 17.2503 5.06934 16.324 5.06934 15.1813C5.06934 14.0386 4.14301 13.1123 3.00033 13.1123C1.85765 13.1123 0.931321 14.0386 0.931321 15.1813Z"
        fill="#BFC6CF"
      />
    </svg>
  ),
  location: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.75C10.2098 3.75 8.4929 4.46116 7.22703 5.72703C5.96116 6.9929 5.25 8.70979 5.25 10.5C5.25 13.7959 6.98067 16.4302 8.78655 18.2792C9.68475 19.1989 10.5851 19.9066 11.2609 20.384C11.5589 20.5945 11.8119 20.7593 12 20.8769C12.1881 20.7593 12.4411 20.5945 12.7391 20.384C13.4149 19.9066 14.3152 19.1989 15.2135 18.2792C17.0193 16.4302 18.75 13.7959 18.75 10.5C18.75 8.70979 18.0388 6.9929 16.773 5.72703C15.5071 4.46116 13.7902 3.75 12 3.75ZM12 21.75C11.6397 22.4078 11.6394 22.4076 11.6391 22.4075L11.6384 22.4071L11.6364 22.406L11.6305 22.4027L11.6105 22.3915C11.5937 22.382 11.5699 22.3685 11.5397 22.351C11.4793 22.316 11.393 22.265 11.2845 22.1982C11.0675 22.0646 10.7612 21.8676 10.3954 21.6091C9.66491 21.0931 8.69025 20.3274 7.71345 19.3273C5.76933 17.3368 3.75 14.3461 3.75 10.5C3.75 8.31196 4.61919 6.21354 6.16637 4.66637C7.71354 3.11919 9.81196 2.25 12 2.25C14.188 2.25 16.2865 3.11919 17.8336 4.66637C19.3808 6.21354 20.25 8.31196 20.25 10.5C20.25 14.3461 18.2307 17.3368 16.2865 19.3273C15.3098 20.3274 14.3351 21.0931 13.6046 21.6091C13.2388 21.8676 12.9325 22.0646 12.7155 22.1982C12.607 22.265 12.5207 22.316 12.4603 22.351C12.4301 22.3685 12.4063 22.382 12.3895 22.3915L12.3695 22.4027L12.3636 22.406L12.3616 22.4071L12.3609 22.4075C12.3606 22.4076 12.3603 22.4078 12 21.75ZM12 21.75L12.3603 22.4078C12.1358 22.5307 11.8642 22.5307 11.6397 22.4078L12 21.75ZM12 8.25C11.4033 8.25 10.831 8.48705 10.409 8.90901C9.98705 9.33097 9.75 9.90326 9.75 10.5C9.75 11.0967 9.98705 11.669 10.409 12.091C10.831 12.5129 11.4033 12.75 12 12.75C12.5967 12.75 13.169 12.5129 13.591 12.091C14.0129 11.669 14.25 11.0967 14.25 10.5C14.25 9.90326 14.0129 9.33097 13.591 8.90901C13.169 8.48705 12.5967 8.25 12 8.25ZM9.34835 7.84835C10.0516 7.14509 11.0054 6.75 12 6.75C12.9946 6.75 13.9484 7.14509 14.6517 7.84835C15.3549 8.55161 15.75 9.50544 15.75 10.5C15.75 11.4946 15.3549 12.4484 14.6517 13.1517C13.9484 13.8549 12.9946 14.25 12 14.25C11.0054 14.25 10.0516 13.8549 9.34835 13.1517C8.64509 12.4484 8.25 11.4946 8.25 10.5C8.25 9.50544 8.64509 8.55161 9.34835 7.84835Z"
        fill="black"
      />
    </svg>
  ),
  assign: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.0409 5.63345H16.7741V4.76386C16.7741 4.29604 16.5882 3.8474 16.2574 3.51661C15.9266 3.18582 15.478 3 15.0102 3H10.0051C9.53733 3 9.08866 3.18582 8.75787 3.51661C8.42707 3.8474 8.24122 4.29604 8.24122 4.76386V5.63345H7.63351C6.9357 5.6341 6.26663 5.91145 5.77297 6.40464C5.27931 6.89784 5.00131 7.56664 5 8.26446V19.3666C5.00131 20.0646 5.27926 20.7337 5.77285 21.2272C6.26644 21.7208 6.93547 21.9987 7.63351 22H17.0409C17.7391 21.9993 18.4085 21.7217 18.9023 21.228C19.396 20.7342 19.6736 20.0648 19.6743 19.3666V8.26446C19.673 7.56664 19.3951 6.89784 18.9014 6.40464C18.4078 5.91145 17.7387 5.6341 17.0409 5.63345ZM9.72348 4.76386C9.72348 4.72687 9.7308 4.69027 9.74495 4.65611C9.7591 4.62194 9.77983 4.59088 9.80599 4.56473C9.83214 4.53858 9.86313 4.51782 9.8973 4.50366C9.93147 4.48951 9.96816 4.48225 10.0051 4.48225H15.0102C15.0471 4.48225 15.0838 4.48951 15.118 4.50366C15.1522 4.51782 15.1832 4.53858 15.2093 4.56473C15.2355 4.59088 15.2562 4.62194 15.2703 4.65611C15.2845 4.69027 15.2918 4.72687 15.2918 4.76386V5.63345H9.72348V4.76386ZM18.192 19.3666C18.192 19.5177 18.1623 19.6674 18.1045 19.8071C18.0466 19.9467 17.9618 20.0737 17.8549 20.1806C17.748 20.2875 17.6211 20.3723 17.4814 20.4301C17.3418 20.488 17.1921 20.5177 17.0409 20.5177H7.63351C7.48233 20.5177 7.33265 20.488 7.19298 20.4301C7.05331 20.3723 6.9263 20.2875 6.8194 20.1806C6.7125 20.0737 6.6278 19.9467 6.56995 19.8071C6.51209 19.6674 6.48225 19.5177 6.48225 19.3666V8.26446C6.48291 7.95956 6.60454 7.66737 6.82037 7.45201C7.03619 7.23665 7.32862 7.1157 7.63351 7.1157H17.0409C17.3458 7.1157 17.6382 7.23665 17.854 7.45201C18.0699 7.66737 18.1914 7.95956 18.192 8.26446V19.3666Z"
        fill="black"
      />
      <path
        d="M9.00928 15.2311L10.9634 17.1901L15.6301 12.521L13.6784 10.5645L9.00928 15.2311Z"
        fill="black"
      />
      <path
        d="M15.4694 9.12649C15.4437 9.09833 15.4125 9.07584 15.3776 9.06045C15.3428 9.04506 15.305 9.03711 15.2669 9.03711C15.2288 9.03711 15.191 9.04506 15.1562 9.06045C15.1213 9.07584 15.0901 9.09833 15.0644 9.12649C14.968 9.21543 14.879 9.3093 14.7851 9.40071L14.0786 10.0974L16.0797 12.0935C16.4082 11.7649 16.7418 11.4363 17.0678 11.1053C17.0945 11.0808 17.1158 11.051 17.1303 11.0178C17.1449 10.9847 17.1524 10.9488 17.1524 10.9126C17.1524 10.8764 17.1449 10.8406 17.1303 10.8074C17.1158 10.7742 17.0945 10.7445 17.0678 10.7199C16.5326 10.1863 15.9997 9.65516 15.4694 9.12649Z"
        fill="black"
      />
      <path
        d="M8.251 16.6195C8.02373 17.1482 7.79639 17.6768 7.57405 18.2055C7.53625 18.282 7.52167 18.3679 7.53207 18.4525C7.56419 18.6502 7.74948 18.7243 7.97429 18.6279L10.131 17.704L10.4817 17.5533L8.64376 15.7153L8.251 16.6195Z"
        fill="black"
      />
    </svg>
  ),
  new_order: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.2935 10.5693H11.7297V13.2053H9.09131V14.7715H11.7297V17.4075H13.2935V14.7715H15.9319V13.2053H13.2935V10.5693Z"
        fill="black"
      />
      <path
        d="M17.0458 5.63345H16.7741V4.76386C16.7741 4.29604 16.5882 3.8474 16.2574 3.51661C15.9266 3.18582 15.478 3 15.0102 3H10.0051C9.5371 3 9.08821 3.18574 8.75702 3.51646C8.42584 3.84718 8.23947 4.29582 8.23881 4.76386V5.63345H7.63351C6.9357 5.6341 6.26663 5.91145 5.77297 6.40464C5.27931 6.89784 5.00131 7.56664 5 8.26446V19.3666C5.00065 20.0648 5.2784 20.7342 5.77213 21.228C6.26586 21.7217 6.93527 21.9993 7.63351 22H17.0409C17.7391 21.9993 18.4086 21.7217 18.9023 21.228C19.396 20.7342 19.6738 20.0648 19.6744 19.3666V8.26446C19.6731 7.5675 19.3957 6.89942 18.9031 6.40636C18.4105 5.91331 17.7428 5.63541 17.0458 5.63345ZM9.72601 4.76386C9.72666 4.68894 9.75688 4.61733 9.81009 4.56458C9.8633 4.51184 9.93516 4.48225 10.0101 4.48225H15.0151C15.0521 4.48225 15.0888 4.48951 15.1229 4.50366C15.1571 4.51782 15.1881 4.53858 15.2143 4.56473C15.2404 4.59088 15.2611 4.62194 15.2753 4.65611C15.2894 4.69027 15.2968 4.72687 15.2968 4.76386V5.63345H9.72601V4.76386ZM18.197 19.3666C18.197 19.5177 18.1673 19.6674 18.1094 19.8071C18.0516 19.9467 17.9667 20.0737 17.8598 20.1806C17.7529 20.2875 17.626 20.3723 17.4864 20.4301C17.3467 20.488 17.197 20.5177 17.0458 20.5177H7.63351C7.48233 20.5177 7.33265 20.488 7.19298 20.4301C7.05331 20.3723 6.92642 20.2875 6.81952 20.1806C6.71262 20.0737 6.6278 19.9467 6.56995 19.8071C6.51209 19.6674 6.48225 19.5177 6.48225 19.3666V8.26446C6.48291 7.95956 6.60454 7.66737 6.82037 7.45201C7.03619 7.23665 7.32862 7.1157 7.63351 7.1157H17.0409C17.3458 7.1157 17.6382 7.23665 17.854 7.45201C18.0699 7.66737 18.1915 7.95956 18.1922 8.26446L18.197 19.3666Z"
        fill="black"
      />
    </svg>
  ),
  user_alt: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3C11.2043 3 10.4413 3.31607 9.87866 3.87868C9.31605 4.44129 8.99998 5.20435 8.99998 6C8.99998 6.79565 9.31605 7.55871 9.87866 8.12132C10.4413 8.68393 11.2043 9 12 9C12.7956 9 13.5587 8.68393 14.1213 8.12132C14.6839 7.55871 15 6.79565 15 6C15 5.20435 14.6839 4.44129 14.1213 3.87868C13.5587 3.31607 12.7956 3 12 3ZM8.818 2.81802C9.66191 1.97411 10.8065 1.5 12 1.5C13.1935 1.5 14.338 1.97411 15.182 2.81802C16.0259 3.66193 16.5 4.80653 16.5 6C16.5 7.19347 16.0259 8.33807 15.182 9.18198C14.338 10.0259 13.1935 10.5 12 10.5C10.8065 10.5 9.66191 10.0259 8.818 9.18198C7.97408 8.33807 7.49998 7.19347 7.49998 6C7.49998 4.80653 7.97408 3.66193 8.818 2.81802ZM12 13.4905C10.2289 13.4905 8.52869 14.1866 7.26614 15.4287C6.12051 16.5558 5.41849 18.0504 5.27667 19.6406C7.34198 20.5158 9.61371 21 12 21H12.001C14.3121 21.0031 16.5982 20.5401 18.7233 19.6404C18.5814 18.0503 17.8794 16.5557 16.7338 15.4287C15.4713 14.1866 13.7711 13.4905 12 13.4905ZM6.21417 14.3594C7.7573 12.8413 9.83527 11.9905 12 11.9905C14.1647 11.9905 16.2427 12.8413 17.7858 14.3594C19.3289 15.8775 20.2135 17.9413 20.2489 20.1058C20.2537 20.4034 20.0821 20.6757 19.8116 20.7997C17.3606 21.9236 14.6953 22.5037 11.999 22.5L12 21.75V22.5C11.9996 22.5 11.9993 22.5 11.999 22.5C9.21321 22.4999 6.56701 21.8916 4.18809 20.7996C3.91768 20.6755 3.74622 20.4032 3.75108 20.1058C3.78643 17.9413 4.67105 15.8775 6.21417 14.3594Z"
        fill="black"
      />
    </svg>
  ),
  refresh: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5405 5.27572C11.6872 4.94708 12.8992 4.91161 14.0634 5.17262C15.2276 5.43364 16.3061 5.98262 17.1983 6.76835C18.0905 7.55409 18.7673 8.55096 19.1655 9.66595C19.2787 9.98294 19.1111 10.3308 18.7912 10.443C18.4713 10.5552 18.1202 10.3892 18.0069 10.0722C17.678 9.15108 17.1189 8.32758 16.3819 7.6785C15.6449 7.02941 14.7539 6.57591 13.7922 6.36029C12.8304 6.14467 11.8292 6.17397 10.882 6.44545C9.93478 6.71693 9.07239 7.22175 8.37532 7.9128L8.36149 7.92609L6.16569 9.97053H8.91566C9.25502 9.97053 9.53012 10.2431 9.53012 10.5794C9.53012 10.9156 9.25502 11.1882 8.91566 11.1882H4.61446C4.2751 11.1882 4 10.9156 4 10.5794V6.31748C4 5.98122 4.2751 5.70863 4.61446 5.70863C4.95381 5.70863 5.22892 5.98122 5.22892 6.31748V9.17181L7.5131 7.04509C8.3557 6.21209 9.39705 5.60345 10.5405 5.27572ZM15.4699 13.4206C15.4699 13.0844 15.745 12.8118 16.0843 12.8118H20.3855C20.7249 12.8118 21 13.0844 21 13.4206V17.6825C21 18.0188 20.7249 18.2914 20.3855 18.2914C20.0462 18.2914 19.7711 18.0188 19.7711 17.6825V14.8282L17.4869 16.9549C16.6443 17.7879 15.603 18.3966 14.4595 18.7243C13.3128 19.0529 12.1008 19.0884 10.9366 18.8274C9.77238 18.5664 8.69386 18.0174 7.80168 17.2316C6.9095 16.4459 6.23273 15.449 5.83454 14.3341C5.72133 14.0171 5.8889 13.6692 6.20881 13.557C6.52873 13.4448 6.87985 13.6108 6.99305 13.9278C7.322 14.8489 7.88107 15.6724 8.61809 16.3215C9.35511 16.9706 10.2461 17.4241 11.2078 17.6397C12.1696 17.8553 13.1708 17.826 14.118 17.5546C15.0652 17.2831 15.9276 16.7782 16.6247 16.0872L16.6385 16.0739L18.8343 14.0295H16.0843C15.745 14.0295 15.4699 13.7569 15.4699 13.4206Z"
        fill="black"
      />
    </svg>
  ),
  image: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 6.5C2 4.01472 4.01472 2 6.5 2H17.5C19.9853 2 22 4.01472 22 6.5V17.5C22 19.9853 19.9853 22 17.5 22H6.5C4.01472 22 2 19.9853 2 17.5V15.5C2 15.2239 2.22386 15 2.5 15C2.77614 15 3 15.2239 3 15.5V17.5C3 19.433 4.567 21 6.5 21H17.5C19.433 21 21 19.433 21 17.5V6.5C21 4.567 19.433 3 17.5 3H6.5C4.567 3 3 4.567 3 6.5V11.5C3 11.7761 2.77614 12 2.5 12C2.22386 12 2 11.7761 2 11.5V6.5Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.45299 11.7549C7.92028 10.9854 6.8208 10.8863 6.15906 11.5481L4.35355 13.3536C4.15829 13.5488 3.84171 13.5488 3.64645 13.3536C3.45118 13.1583 3.45118 12.8417 3.64645 12.6464L5.45195 10.8409C6.55485 9.73804 8.38733 9.90326 9.27517 11.1856L11.1775 13.9334C11.676 14.6534 12.6828 14.7951 13.3606 14.2405L15.7825 12.259C16.7766 11.4457 18.2252 11.518 19.1334 12.4262L21.8536 15.1465C22.0488 15.3417 22.0488 15.6583 21.8535 15.8536C21.6583 16.0488 21.3417 16.0488 21.1464 15.8535L18.4263 13.1333C17.8814 12.5884 17.0122 12.545 16.4158 13.033L13.9939 15.0145C12.8642 15.9388 11.1862 15.7027 10.3553 14.5026L8.45299 11.7549Z"
        fill="black"
      />
      <path
        d="M18 7.5C18 8.32843 17.3284 9 16.5 9C15.6716 9 15 8.32843 15 7.5C15 6.67157 15.6716 6 16.5 6C17.3284 6 18 6.67157 18 7.5Z"
        fill="black"
      />
    </svg>
  ),
  document: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.25 3H6.75C4.68 3 3 4.68 3 6.75V17.25C3 19.32 4.68 21 6.75 21H17.25C19.32 21 21 19.32 21 17.25V6.75C21 4.68 19.32 3 17.25 3ZM19.5 17.25C19.5 18.4875 18.4875 19.5 17.25 19.5H6.75C5.5125 19.5 4.5 18.4875 4.5 17.25V6.75C4.5 5.5125 5.5125 4.5 6.75 4.5H17.25C18.4875 4.5 19.5 5.5125 19.5 6.75V17.25ZM6.75 10.5C6.75 10.0875 7.0875 9.75 7.5 9.75H14.25C14.6625 9.75 15 10.0875 15 10.5C15 10.9125 14.6625 11.25 14.25 11.25H7.5C7.0875 11.25 6.75 10.9125 6.75 10.5ZM6.75 7.5C6.75 7.0875 7.0875 6.75 7.5 6.75H12C12.4125 6.75 12.75 7.0875 12.75 7.5C12.75 7.9125 12.4125 8.25 12 8.25H7.5C7.0875 8.25 6.75 7.9125 6.75 7.5ZM17.25 13.5C17.25 13.9125 16.9125 14.25 16.5 14.25H7.5C7.0875 14.25 6.75 13.9125 6.75 13.5C6.75 13.0875 7.0875 12.75 7.5 12.75H16.5C16.9125 12.75 17.25 13.0875 17.25 13.5ZM10.5 16.5C10.5 16.9125 10.1625 17.25 9.75 17.25H7.5C7.0875 17.25 6.75 16.9125 6.75 16.5C6.75 16.0875 7.0875 15.75 7.5 15.75H9.75C10.1625 15.75 10.5 16.0875 10.5 16.5Z"
        fill="black"
      />
    </svg>
  ),
  minus: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 13C3.44772 13 3 12.5523 3 12V12C3 11.4477 3.44772 11 4 11H20C20.5523 11 21 11.4477 21 12V12C21 12.5523 20.5523 13 20 13H4Z"
        fill="black"
      />
    </svg>
  ),
  chevronLeft: (
    <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24" width="24" height="24">
      <path d="M10.6,12.71a1,1,0,0,1,0-1.42l4.59-4.58a1,1,0,0,0,0-1.42,1,1,0,0,0-1.41,0L9.19,9.88a3,3,0,0,0,0,4.24l4.59,4.59a1,1,0,0,0,.7.29,1,1,0,0,0,.71-.29,1,1,0,0,0,0-1.42Z" />
    </svg>
  ),
  close: (
    <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.50011 0.9254C9.35946 0.784797 9.16873 0.705811 8.96986 0.705811C8.77098 0.705811 8.58025 0.784797 8.43961 0.9254L5.00011 4.3649L1.56061 0.9254C1.41996 0.784797 1.22923 0.705811 1.03036 0.705811C0.831484 0.705811 0.640753 0.784797 0.500108 0.9254C0.359504 1.06605 0.280518 1.25678 0.280518 1.45565C0.280518 1.65452 0.359504 1.84525 0.500108 1.9859L3.93961 5.4254L0.500108 8.8649C0.359504 9.00555 0.280518 9.19628 0.280518 9.39515C0.280518 9.59402 0.359504 9.78475 0.500108 9.9254C0.640753 10.066 0.831484 10.145 1.03036 10.145C1.22923 10.145 1.41996 10.066 1.56061 9.9254L5.00011 6.4859L8.43961 9.9254C8.58025 10.066 8.77098 10.145 8.96986 10.145C9.16873 10.145 9.35946 10.066 9.50011 9.9254C9.64071 9.78475 9.7197 9.59402 9.7197 9.39515C9.7197 9.19628 9.64071 9.00555 9.50011 8.8649L6.06061 5.4254L9.50011 1.9859C9.64071 1.84525 9.7197 1.65452 9.7197 1.45565C9.7197 1.25678 9.64071 1.06605 9.50011 0.9254Z"
        fill="#2A3038"
      />
    </svg>
  ),
  clock: (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22.1753C17.3848 22.1753 21.75 17.8101 21.75 12.4253C21.75 7.04052 17.3848 2.67529 12 2.67529C6.61522 2.67529 2.25 7.04052 2.25 12.4253C2.25 17.8101 6.61522 22.1753 12 22.1753ZM10.5 4.92529H12.75V11.9327L17.2631 16.0986L15.7369 17.7519L10.5 12.9179V4.92529Z"
        fill="#2A3038"
        fillOpacity="0.15"
      />
      <path
        d="M10.5 4.92529V12.9179L15.7369 17.7519L17.2631 16.0986L12.75 11.9327V4.92529H10.5Z"
        fill="#2A3038"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 12.4253C24 19.0527 18.6274 24.4253 12 24.4253C5.37258 24.4253 0 19.0527 0 12.4253C0 5.79788 5.37258 0.425293 12 0.425293C18.6274 0.425293 24 5.79788 24 12.4253ZM21.75 12.4253C21.75 17.8101 17.3848 22.1753 12 22.1753C6.61522 22.1753 2.25 17.8101 2.25 12.4253C2.25 7.04052 6.61522 2.67529 12 2.67529C17.3848 2.67529 21.75 7.04052 21.75 12.4253Z"
        fill="#2A3038"
      />
    </svg>
  ),
  angle_down: (
    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 5.96913L0.974524 0.925293L0 1.90338L6 7.92529L12 1.90338L11.0255 0.925293L6 5.96913Z"
        fill="black"
      />
    </svg>
  ),
  static: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.25 2.5H14.5V13.5H11.25V2.5ZM5 10.5V13.5H1.5V10.5H5Z"
        fill="#2A3038"
        fillOpacity="0.15"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.75 5V1H16V15H0V9H5V5H9.75ZM11.25 2.5H14.5V13.5H11.25V2.5ZM9.75 6.5H6.5V13.5H9.75V6.5ZM5 10.5V13.5H1.5V10.5H5Z"
        fill="#2A3038"
      />
    </svg>
  ),
  star: (
    <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24" width="17" height="17">
      <path d="M23.836,8.794a3.179,3.179,0,0,0-3.067-2.226H16.4L15.073,2.432a3.227,3.227,0,0,0-6.146,0L7.6,6.568H3.231a3.227,3.227,0,0,0-1.9,5.832L4.887,15,3.535,19.187A3.178,3.178,0,0,0,4.719,22.8a3.177,3.177,0,0,0,3.8-.019L12,20.219l3.482,2.559a3.227,3.227,0,0,0,4.983-3.591L19.113,15l3.56-2.6A3.177,3.177,0,0,0,23.836,8.794Zm-2.343,1.991-4.144,3.029a1,1,0,0,0-.362,1.116L18.562,19.8a1.227,1.227,0,0,1-1.895,1.365l-4.075-3a1,1,0,0,0-1.184,0l-4.075,3a1.227,1.227,0,0,1-1.9-1.365L7.013,14.93a1,1,0,0,0-.362-1.116L2.507,10.785a1.227,1.227,0,0,1,.724-2.217h5.1a1,1,0,0,0,.952-.694l1.55-4.831a1.227,1.227,0,0,1,2.336,0l1.55,4.831a1,1,0,0,0,.952.694h5.1a1.227,1.227,0,0,1,.724,2.217Z" />
    </svg>
  ),
  user_circle: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.34106 9C6.81621 9.31592 7.38659 9.5 7.99996 9.5C8.61333 9.5 9.1837 9.31592 9.65885 9C10.4672 8.46254 11 7.54349 11 6.5C11 4.84315 9.65681 3.5 7.99996 3.5C6.3431 3.5 4.99996 4.84315 4.99996 6.5C4.99996 7.54349 5.53271 8.46254 6.34106 9ZM7.99996 8C8.82838 8 9.49996 7.32843 9.49996 6.5C9.49996 5.67157 8.82838 5 7.99996 5C7.17153 5 6.49996 5.67157 6.49996 6.5C6.49996 7.32843 7.17153 8 7.99996 8Z"
        fill="#2A3038"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM11.4998 13.4783C10.4895 14.1251 9.28856 14.5 8 14.5C6.7114 14.5 5.51039 14.125 4.50011 13.4783C4.51174 12.6599 5.17879 12 5.99996 12H9.99996C10.8211 12 11.4882 12.6599 11.4998 13.4783ZM12.7896 12.3943C12.3567 11.3029 11.3018 10.5259 10.0623 10.5006C10.0416 10.5002 10.0208 10.5 9.99996 10.5H5.99996C5.97912 10.5 5.95832 10.5002 5.93758 10.5006C4.69813 10.5259 3.64327 11.3029 3.21032 12.3942C2.14827 11.2373 1.5 9.69433 1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8C14.5 9.69436 13.8517 11.2373 12.7896 12.3943Z"
        fill="#2A3038"
      />
    </svg>
  ),
};

export interface IIcon {
  slug?: string;
  style?: React.CSSProperties;
  className?: string;
  size?: number;
  color?: string;
}

const Icon = ({ style, slug = '', className, size, color }: IIcon) => {
  return slug in customIcons ? (
    <span
      className={$class('ui-icon-svg', (size || color) && 'ui-icon')}
      style={{
        ...(size ? { ['--ui-icon-size' as string]: size + 'px' } : {}),
        ...(color ? { ['--ui-icon-color' as string]: color } : {}),
        display: 'flex',
      }}
    >
      {customIcons[slug]}
    </span>
  ) : (
    <i style={{ lineHeight: 0 }} className={$class(`ui-icon fi ${slug}`, className)}></i>
  );
};

export default Icon;
